import React from 'react';

import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';
import IconButton from 'components/clarity-ui/inputs/iconButton';
import Input from 'components/clarity-ui/inputs/inputField/inputField';

class WeightedLabelsTableComponent extends React.Component {

  renderTableRows () {
    const { clfTarget, handleRemoveWeightedLabelsOnClick, handleWeightInputOnChange } = this.props;
    const { weightedClfTargets } = clfTarget;
    let tableRows = [];

    tableRows = weightedClfTargets.filter((item) => {
      return (!item.action || item.action !== 'delete');
    }).map((item) => {
      const { labelId, label, weight, error } = item;
      const { labelType, name } = label;
      return (
        <TableRow key={labelId}>
          <TableData>{labelId}</TableData>
          <TableData>{name}</TableData>
          <TableData>{labelType}</TableData>
          <TableData style={{maxWidth: 109 + 'px'}}><Input size="5" value={weight} errorMsg={error} onChange={handleWeightInputOnChange.bind(this, item)}/></TableData>
          <TableData><IconButton onClick={handleRemoveWeightedLabelsOnClick.bind(this, item)} iconClass="trash"/></TableData>
        </TableRow>
      );
    });

    if (tableRows.length === 0) {
      tableRows.push(
        <TableRow key='empty-weighted-cfl-target-table'>
          <TableData colSpan={5} style={{maxWidth: 50+'px'}}>No labels found</TableData>
        </TableRow>
      );
    }

    return tableRows;
  }

  render () {
    return (
      <Table>
        <thead>
          <TableRow isHeader>
            <TableHeader>Id</TableHeader>
            <TableHeader>Label Name</TableHeader>
            <TableHeader>Label Type</TableHeader>
            <TableHeader>Weight</TableHeader>
            <TableHeader></TableHeader>
          </TableRow>
        </thead>
        <tbody>
          { this.renderTableRows() }
        </tbody>
      </Table>
    );
  }
}

export default WeightedLabelsTableComponent;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/attachedLabels/weightedLabelsTable.component.jsx